<script lang="ts">
	import { page } from '$app/state'
	import PageTitle from '$lib/public/PageTitle.svelte'
</script>

<PageTitle>Error</PageTitle>
<h4>{page.status} : {page.error?.message}</h4>
